import { render } from "./MLearningSummarySection.vue?vue&type=template&id=2b66edc0"
import script from "./MLearningSummarySection.vue?vue&type=script&lang=ts"
export * from "./MLearningSummarySection.vue?vue&type=script&lang=ts"
script.render = render

export default script